<template>
    <v-dialog
        v-model="showModal"
        persistent
        max-width="500"
    >
        <v-card>
            <v-card-title class="headline">
                Error
            </v-card-title>
            <v-card-text>
                <v-card-subtitle class="text-h6">{{messages[messageCode]}}</v-card-subtitle>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    @click="closeErrorModal()"
                >
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ErrorModal",
    props: ['showModal', 'messageCode', 'closeErrorModal'],
    data(){
        return {
            messages: [
                'La información que seleccionaste en Datos de solicitante no contiene un RFC para la facturación.',
                'Los datos que intentas seleccionar no cuentan con un RFC válido.',
                'Debe seleccionar un dato de solicitante',
                'Debe seleccionar el dato solicitante para cada elemento de la lista.'
            ]
        }
    }
}
</script>

<style scoped>

</style>